export const normalizePlate = (value = "") => String(value).toUpperCase().replace(/[\s-]/g, "");
export const isValidPlate = (value) => /^[A-Z]{3}(?:\d{3}|\d{2}[A-Z])$/.test(normalizePlate(value));
export const plateCommerceId = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") return null;
  if (!["string", "number"].includes(typeof value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id >= 0 ? id : null;
};
export const PLATE_STATES = {
  cerberus: {
    1: ["Permitido", "success", "Ingreso y salida permitidos"],
    2: ["No permitido", "error", "Ingreso y salida no permitidos"],
    3: ["Sin ingreso", "warning", "Ingreso no permitido"],
    4: ["Sin salida", "warning", "Salida no permitida"],
  },
  vehicle: {
    1: ["Activo", "success"],
    2: ["Cancelado", "error"],
    3: ["Suspendido por el administrador", "warning"],
    4: ["Suspendido por pago pendiente", "warning"],
    5: ["Suspendido por intento de fraude", "error"],
    6: ["Suspendido por reintentos de tarjeta", "warning"],
  },
  user: {
    1: ["Pendiente", "info"],
    2: ["Preactivo", "info"],
    3: ["Activo", "success"],
    4: ["Desvinculado", "info"],
    5: ["Cancelado", "error"],
    6: ["Bloqueado por el administrador", "error"],
    7: ["Suspendido por saldo o medio de pago", "warning"],
    8: ["Bloqueado por fraude", "error"],
    9: ["Suspendido por reintentos de tarjeta", "warning"],
    10: ["Suspendido por falta de medio de pago", "warning"],
  },
};
export function plateState(value, kind, description) {
  const state = PLATE_STATES[kind]?.[value];
  return {
    label:
      state?.[0] ||
      (value !== null && value !== undefined && value !== ""
        ? `Estado ${value}`
        : "Sin información"),
    severity: state?.[1] || "info",
    description: description || state?.[2] || state?.[0] || "El servicio no informa este estado",
    code: value ?? null,
  };
}
export function plateList(value) {
  const key = typeof value === "string" ? value.trim().toLowerCase() : "";
  const states = {
    blanca: ["Lista blanca", "success"],
    gris: ["Lista gris", "warning"],
    negra: ["Lista negra", "error"],
    autorizados: ["Autorizados", "success"],
    "sin lista": ["Sin lista", "info"],
  };
  return {
    label: states[key]?.[0] || value || "Sin información",
    severity: states[key]?.[1] || "info",
  };
}
export function plateDate(value) {
  if (!value || value === "N/A" || value === "Sin lista") return "Sin registro";
  const normalized = String(value).replace(
    /^(\d{4}-\d\d-\d\d) (\d\d:\d\d:\d\d(?:\.\d+)?) ([+-]\d\d)(\d\d)$/,
    "$1T$2$3:$4"
  );
  const calendarPattern =
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?$/;
  const calendar = calendarPattern.exec(normalized);
  if (calendar) {
    const [, year, month, day, hour, minute, second] = calendar;
    const checked = new Date(
      `${year}-${month}-${day}T${hour || "00"}:${minute || "00"}:${second || "00"}Z`
    );
    if (
      isNaN(checked.getTime()) ||
      checked.toISOString().slice(0, 10) !== `${year}-${month}-${day}`
    )
      return "Fecha no válida";
    return `${day}/${month}/${year}${
      hour ? `, ${hour}:${minute}:${second || "00"} (sin zona horaria)` : ""
    }`;
  }
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return "Fecha no válida";
  return new Intl.DateTimeFormat("es-CO", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).format(date);
}
export function normalizePlateResult(info, plate) {
  return {
    ...info,
    plate: normalizePlate(info.plate || plate),
    status: info.status ?? null,
    status_vehicle_poseidon: info.status_vehicle_poseidon ?? null,
    status_user_poseidon: info.status_user_poseidon ?? null,
    vehicle_list_commerce_poseidon: info.vehicle_list_commerce_poseidon ?? null,
    raw: info,
  };
}
